import type { RawParams } from "@uirouter/core";

import type { SignalsDigestParams } from "app/pages/sales-intelligence/sub-modules/signals/types";

export const getSignalsDigestParams = (routeParams: RawParams): SignalsDigestParams => {
    const { digestType, digestDate, signalId, signalSubType, domain } = routeParams;

    return {
        digestType,
        digestDate,
        signalSubType,
        signalId: signalId ?? "any",
        domain: domain ?? null,
    };
};
